import Swiper, { Navigation } from 'swiper';

import {
    equalizeCardsContentHeight,
    fixAccessibilityRemoveIdsFromDuplicateSlides,
} from '../../../../../global/js/helpers';

function CardsA4() {
    Swiper.use([Navigation]);

    $('[data-module="cardsA4"]').each(function () {
        const module = $(this);

        const swiper = new Swiper(module.find('[data-slider]')[0], {
            slidesPerView: 'auto',

            loop: true,

            lazy: true,

            navigation: {
                prevEl: module.find('.js-slider-prev')[0],
                nextEl: module.find('.js-slider-next')[0],
            },

            on: {
                init: function (e) {
                    equalizeCardsContentHeight(e);

                    setTimeout(
                        () => fixAccessibilityRemoveIdsFromDuplicateSlides(e),
                        1000,
                    );
                },
                resize: function (e) {
                    equalizeCardsContentHeight(e);
                },
            },
        });

        swiper.on('progress', function (e, progress) {
            if (progress <= 0) {
                module
                    .find('.js-slider-prev')
                    .addClass('a-btn-pagination--disabled');
            } else {
                module
                    .find('.js-slider-prev')
                    .removeClass('a-btn-pagination--disabled');
            }

            if (progress >= 1) {
                module
                    .find('.js-slider-next')
                    .addClass('a-btn-pagination--disabled');
            } else {
                module
                    .find('.js-slider-next')
                    .removeClass('a-btn-pagination--disabled');
            }
        });

        if (swiper.isBeginning) {
            module
                .find('.js-slider-prev')
                .addClass('a-btn-pagination--disabled');
        }

        if (swiper.isEnd) {
            module
                .find('.js-slider-next')
                .addClass('a-btn-pagination--disabled');
        }
    });
}

export default CardsA4;
